// SPDX-License-Identifier: AGPL-3.0-or-later

const ready = (callback: () => void) => {
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", callback);
  else callback();
};

ready(() => {
  const root = document.documentElement;
  const query = document.querySelector<HTMLInputElement>("#q");

  // A restrained pointer glow gives mouse users tactile depth without affecting touch devices.
  document.addEventListener("pointermove", (event) => {
    root.style.setProperty("--qatrix-pointer-x", `${event.clientX}px`);
    root.style.setProperty("--qatrix-pointer-y", `${event.clientY}px`);
  });

  for (const button of document.querySelectorAll<HTMLElement>("[data-qatrix-prompt]")) {
    button.addEventListener("click", () => {
      if (!query) return;
      query.value = button.dataset.qatrixPrompt ?? "";
      query.dispatchEvent(new Event("input", { bubbles: true }));
      query.focus();
      query.setSelectionRange(query.value.length, query.value.length);
    });
  }

  for (const mode of document.querySelectorAll<HTMLButtonElement>("[data-qatrix-mode]")) {
    mode.addEventListener("click", () => {
      for (const item of document.querySelectorAll("[data-qatrix-mode]")) item.classList.remove("active");
      mode.classList.add("active");
      if (!query) return;
      const selectedMode = mode.dataset.qatrixMode ?? "Search";
      query.placeholder = selectedMode === "Search" ? "Search the open web…" : `${selectedMode} anything…`;
      query.focus();
    });
  }

  document.addEventListener("keydown", (event) => {
    if (event.key === "/" && document.activeElement?.tagName !== "INPUT" && document.activeElement?.tagName !== "TEXTAREA") {
      event.preventDefault();
      query?.focus();
    }
  });

  const briefButton = document.querySelector<HTMLButtonElement>("#qatrix-generate-brief");
  const briefOutput = document.querySelector<HTMLElement>(".qatrix-ai-output");
  briefButton?.addEventListener("click", () => {
    if (!briefOutput) return;
    briefButton.disabled = true;
    briefButton.textContent = "Analyzing results…";
    window.setTimeout(() => {
      const cards = [...document.querySelectorAll<HTMLElement>("#urls article.result")].slice(0, 5);
      const findings = cards.map((card) => {
        const title = card.querySelector("h3")?.textContent?.trim();
        const summary = card.querySelector<HTMLElement>(".content")?.textContent?.trim();
        if (!title) return "";
        const trimmed = summary && summary.length > 180 ? `${summary.slice(0, 177).trim()}…` : summary;
        return `<li><strong>${escapeHtml(title)}</strong>${trimmed ? `<span>${escapeHtml(trimmed)}</span>` : ""}</li>`;
      }).filter(Boolean);
      briefOutput.innerHTML = findings.length > 0
        ? `<p>Key signals across the top ${findings.length} results:</p><ol>${findings.join("")}</ol><small>Local extractive summary · verify important claims with the cited results.</small>`
        : "<p>No readable result summaries were available on this page.</p>";
      briefOutput.hidden = false;
      briefButton.textContent = "Refresh brief";
      briefButton.disabled = false;
      briefOutput.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }, 650);
  });
});

function escapeHtml(value: string): string {
  const element = document.createElement("span");
  element.textContent = value;
  return element.innerHTML;
}
